import { AppType } from './app';
import { PermissionNameEnum, RolePermissionEnum } from '@Types/permissions';

export interface EuqSettingsList {
  euq_assistant: EuqAssistantList;
  euq_feedback: EuqFeedbackEnable;
  euq_feedback_skip_on_approved_header: EuqFeedbackSkipOnApprovedHeader;
  euq_feedback_manual_approve: {
    isEnabled: number;
  };
  euq_feedback_phishing_spam_auto_remediation: {
    isEnabled: number;
  };
  euq_feedback_to_admin: EuqFeedbackToAdmin;
  euq_move_to_junk_folder: EuqMoveToJunkFolderEnable;
  euq_send_confirmation_mail: EuqSendConfirmationMail;
  outlook_addin_ai_chat: {
    isEnabled: number;
  };
}
export interface EuqAssistantList {
  approved_sender: {
    enabled: number;
  };
  isEnabled: number;
  threat_type: EuqThreatTypeItem;
}
export enum EuqThreatTypeEnum {
  BEC = 'BEC',
  Spoofing = 'Spoofing',
  Phishing = 'Phishing',
  Ransomware = 'Ransomware',
  MaliciousFile = 'Malicious File',
  MaliciousURL = 'Malicious URL',
  Spam = 'Spam',
  Blocked = 'Blocked',
  UntestedOrUnScannable = 'UntestedOrUnscannable',
  DLP = 'DLP',
  ActiveContent = 'Active Content',
  SuspiciousObject = 'Suspicious Object',
  SuspiciousDetect = 'Spam',
}
export type EuqThreatTypeItem = {
  [key in EuqThreatTypeEnum]: {
    view: number;
    take_action: number;
  };
};

export interface RoleProps {
  roleId: string;
  roleName: string;
  userCount: number;
  roleDescription: string;
  isDefault: boolean;
  ogrIds: string[] | string;
  permissions?: {
    [key in RolePermissionEnum]: PermissionValueEnum;
  };
  [key: string]: any;
}

export enum Action {
  DELETE = 'DELETE',
  UPDATE = 'UPDATE',
  CREATE = 'CREATE',
  RESETPASSWORD = 'RESETPASSWORD',
}
export interface AdministratorProps {
  email: string;
  userDisplayname: string;
  verifiedEmail: number;
  accountType: number;
  ssoEnabled: number;
  multiTenantEmail: null;
  tenantSwitchable: boolean;
  isInheritUser: boolean;
  roleId: string;
  targetType: number;
  roleName: string;
  roleDescription: string;
  [key: string]: any;
}

export interface CreateAdmin {
  email: string;
  userDisplayname: string;
  roleId: string;
  ssoEnabled: number;
  isInheritUser: boolean;
  language?: string;
}

export interface UpdateAdmin {
  roleId: string;
  ssoEnabled?: number;
  language?: string;
}

export interface RoleTarget {
  target: string;
  displayName: string;
  targetType?: number;
  orgId?: string;
}

export interface RolePermission {
  permissionName: PermissionNameEnum;
  permissionValues: number;
}
export interface CreateRoleReqDto {
  roleName: string;
  roleDescription: string;
  orgIds: string[] | 'all';
  roleTargets?: RoleTarget[];
  permissions: {
    [key in RolePermissionEnum]: PermissionValueEnum;
  };
  language: string;
}

export enum PermissionValueEnum {
  ViewOnly = 1,
  Editable = 2,
  NoAccess = 0,
}

export interface EuqFeedbackEnable {
  isEnabled: number;
}
export interface EuqFeedbackSkipOnApprovedHeader {
  isEnabled: number;
}
export interface EuqSetDataList {
  type: string;
  view: number;
  take_action: number;
}
export interface EuqFeedbackToAdmin {
  isEnabled: number;
  euq_feedback_mail_boxes: string[];
}

export interface EuqMoveToJunkFolderEnable {
  isEnabled: number;
}

export interface EuqSendConfirmationMail {
  confirmationMailConfig: ConfirmationMailConfig;
  isEnabled: number;
}

export interface ConfirmationMailConfig {
  customizedMail: number;
  subject: string;
  mailContent: string;
}

export interface EuqFeedbackToEndUser {
  isEnabled: boolean;
  mailTemplate: {
    isDefault: boolean;
    subject: string;
    content: string;
  };
}

export interface EuqEmailReportResponse {
  euqFeedbackToEndUser: EuqFeedbackToEndUser;
  euq_feedback: {
    isEnabled: number;
  };
  euq_feedback_skip_on_approved_header: {
    isEnabled: number;
  };
  euq_feedback_manual_approve: {
    isEnabled: number;
  };
  euq_feedback_to_admin: {
    isEnabled: number;
    euq_feedback_mail_boxes: string[];
  };
  euq_move_to_junk_folder: {
    isEnabled: number;
  };
  euq_send_confirmation_mail: {
    isEnabled: number;
    confirmationMailConfig: ConfirmationMailConfig;
  };
  euq_feedback_phishing_spam_auto_remediation: {
    isEnabled: number;
  };
  euq_auto_collect?: {
    isEnabled: number;
  };
  euq_auto_collect_source_type?: {
    sourceType: 'Microsoft' | 'Other';
  };
  euq_auto_collect_mailbox?: {
    mailboxes: string[];
  };
}

export interface EuqEmailReportUpdateRequest {
  euqFeedbackToEndUser: EuqFeedbackToEndUser;
  euq_feedback?: {
    isEnabled: number;
  };
  euq_feedback_skip_on_approved_header?: {
    isEnabled: number;
  };
  euq_feedback_manual_approve?: {
    isEnabled: number;
  };
  euq_feedback_to_admin?: {
    isEnabled: number;
    euq_feedback_mail_boxes: string[];
  };
  euq_move_to_junk_folder?: {
    isEnabled: number;
  };
  euq_send_confirmation_mail?: {
    isEnabled: number;
    confirmationMailConfig: ConfirmationMailConfig;
  };
  euq_feedback_phishing_spam_auto_remediation?: {
    isEnabled: number;
  };
  euq_auto_collect?: {
    isEnabled: number;
  };
  euq_auto_collect_source_type?: {
    sourceType: 'Microsoft' | 'Other';
  };
  euq_auto_collect_mailbox?: {
    mailboxes: string[];
  };
}

//sa页面展示的app
export enum AppForSa {
  Exchange = 'exchange',
  Box = 'box',
  Dropbox = 'dropbox',
  GoogleDrive = 'googleDrive',
  SharePoint = 'sharePoint',
  OneDrive = 'oneDrive',
  Gmail = 'gmail',
  GmailInline = 'gmailInline',
  //Mitigation = 'mitigation', //??need show??
  //Soc = 'soc', //??need show??
  //SocManagement = 'socManagement', //??need show??
  IdentityProtection = 'identityProtection',
  Teams = 'teams',
  TeamsChat = 'teamsChat',
  Mip = 'mip',
  ExchangeServer = 'exchangeServer',
  ExchangeInline = 'exchangeInline',
  SalesforceSandbox = 'salesforceSandbox',
  SalesforceProduction = 'salesforceProduction',
  DeprecatedSpod = 'deprecatedSpod',
  RMS = 'rms',
}

export const AppForSa2AppType: Record<
  Exclude<AppForSa, 'deprecatedSpod' | 'rms'>,
  AppType
> = {
  [AppForSa.Exchange]: AppType.Exchange,
  [AppForSa.Box]: AppType.Box,
  [AppForSa.Dropbox]: AppType.Dropbox,
  [AppForSa.GoogleDrive]: AppType.GoogleDrive,
  [AppForSa.SharePoint]: AppType.SharePoint,
  [AppForSa.OneDrive]: AppType.OneDrive,
  [AppForSa.Gmail]: AppType.Gmail,
  [AppForSa.GmailInline]: AppType.GmailInline,
  [AppForSa.IdentityProtection]: AppType.IdentityProtection,
  [AppForSa.Teams]: AppType.Teams,
  [AppForSa.TeamsChat]: AppType.TeamsChat,
  [AppForSa.Mip]: AppType.Mip,
  [AppForSa.ExchangeServer]: AppType.ExchangeServer,
  [AppForSa.ExchangeInline]: AppType.ExchangeInline,
  [AppForSa.SalesforceProduction]: AppType.SalesforceProduction,
  [AppForSa.SalesforceSandbox]: AppType.SalesforceSandbox,
};

export enum ServiceForReAuth {
  Exchange = 'exchange',
  Box = 'box',
  Dropbox = 'dropbox',
  GoogleDrive = 'googleDrive',
  SharePoint = 'sharePoint',
  OneDrive = 'oneDrive',
  Gmail = 'gmail',
  GmailInline = 'gmailInline',
  Teams = 'teams',
  TeamsChat = 'teamsChat',
  Mip = 'mip',
  ExchangeInline = 'exchangeInline',
  O365AuditLog = 'o365AuditLog',
  IdentityProtection = 'identityProtection',
}

export enum DeProvisionStatus {
  NotStarted = 'notStarted',
  DeProvisioned = 'deProvisioned',
  DeProvisioning = 'deProvisioning',
  Failure = 'failure',
}

//api type
export interface DelegatorAccountResDto {
  companyGuid: string;
  email: string;
  app: AppForSa;
  valid: boolean;
  provisionFromGraphapi: number | null;
  migrationStatus: number;
  endDate: string;
  status: number;
  extra: number;
  provisionType: number;
  pocProvision?: 0 | 1;
}
export interface ReAuthAvailableAppResDto {
  [orgId: string]: AppForSa[];
}

export interface DeprovisioningAppResDto {
  [orgId: string]: {
    [app in AppForSa]?: {
      status: DeProvisionStatus.DeProvisioning | DeProvisionStatus.Failure;
    };
  };
}

export interface DeprovisionDetail {
  key: string;
  remaining: string;
  status: string;
}

export enum TokenForScope {
  intelligent = 'intelligent',
  remediation = 'remediation',
  sweeping = 'sweeping',
  mitigation = 'mitigation',
  siem = 'siem',
}
export interface AuthenticateTokenResDto {
  [key: string]: AuthenticateTokenList[];
}
export interface AuthenticateTokenList {
  accessToken: string;
  category: number;
  description: string;
  expiredAt: string;
  name: string;
  scope: string;
  tokenType: string;
}
export interface ApiTokenDto {
  category: number;
  description: string;
  name: string;
  scope: string;
}
export interface UpdateApiToken {
  accessToken: string;
  description?: string;
  name?: string;
  scope: string;
}

export interface SsoConfigDto {
  enableSamlSso: number;
  idpLoginUrl: string | null;
  identifiedName: string | null;
  certificate: string | null;
  idpType: number | null;
}
